/* oxlint-disable react/jsx-pascal-case */
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExclamationCircle } from '@fortawesome/pro-solid-svg-icons/faExclamationCircle';

import React from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import { TH } from '../../providers/providers-list/reuseable-table/components';
import { CarrierRow } from './carrier-row';
import messages from '../messages';
import carrierStyles from './carriers-additional.module.less';
import { Tooltip } from 'ui-components/components/tooltip';
import { TooltipContent } from 'ui-components/components/tooltip/tooltip-content';
import { useIsSellerFeatureEnabled } from '../../../../hooks/use-is-seller-feature-enabled';
import { Features } from '../../../../constants/features';
import { EmptyCarrierTableBody } from './empty-carrier-table-body';

const CarrierTable = ({ sellerLabelProviderIds }) => {
  const isSellerFeatureApiV2Enabled = useIsSellerFeatureEnabled(Features.ShipStationApiV2);
  const showCarrierId = isSellerFeatureApiV2Enabled;

  const showEmptyTable = !sellerLabelProviderIds?.length;

  return (
    <table
      className={classnames(carrierStyles['carrier-table'], {
        [carrierStyles['carrier-table-4-columns']]: showCarrierId,
      })}
    >
      <thead>
        <tr>
          <TH key='name' className={carrierStyles['provider-name-cell']}>
            <FormattedMessage {...messages.tableHeaderCarrier} />
          </TH>
          <TH key='services' className={carrierStyles['services-cell']}>
            <FormattedMessage {...messages.tableHeaderServices} />
          </TH>
          {showCarrierId && (
            <TH key='carrierId' className={carrierStyles['carrier-id-cell']}>
              <span>
                <FormattedMessage {...messages.tableHeaderCarrierId} />
              </span>
              <Tooltip position='bottom'>
                <div className={carrierStyles['header-tooltip']}>
                  <FontAwesomeIcon className={carrierStyles['header-icon']} icon={faExclamationCircle} />
                </div>
                <TooltipContent>
                  <FormattedMessage {...messages.carrierIdTooltip} />
                </TooltipContent>
              </Tooltip>
            </TH>
          )}
          <TH key='actions' className={carrierStyles['actions-cell']}>
            <FormattedMessage {...messages.tableHeaderActions} />
          </TH>
        </tr>
      </thead>
      <tbody>
        {showEmptyTable ? (
          <EmptyCarrierTableBody />
        ) : (
          sellerLabelProviderIds.map((sellerLabelProviderId) => {
            return <CarrierRow key={sellerLabelProviderId} sellerLabelProviderId={sellerLabelProviderId} showCarrierId={showCarrierId} />;
          })
        )}
      </tbody>
    </table>
  );
};

CarrierTable.propTypes = {
  sellerLabelProviderIds: PropTypes.arrayOf(PropTypes.string).isRequired,
};

export default CarrierTable;
